import { Button, Form, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { useEmployeeOwnDataUpdate } from 'src/hooks/employees/update-own-data.hook';
import { PaymentAndInsuranceFields } from 'src/components/employee/payment-and-insurance/payment-and-insurance-fields';

import { IPaymentAndInsurance } from 'src/components/employee/employee.interfaces';
import { EditFormWrapper } from '../../../own-data.styles';

const PaymentAndInsuranceEdit = ({
  onCancel,
  initialValues,
}: {
  onCancel: () => void;
  initialValues: IPaymentAndInsurance;
}) => {
  const { t } = useTranslation(['employee', 'common']);

  const [form] = Form.useForm();

  const memberOwnDataUpdate = useEmployeeOwnDataUpdate({ onSuccess: onCancel });

  const onFinish = (values: any) => {
    memberOwnDataUpdate({
      variables: {
        payload: {
          paymentAndInsurance: values?.paymentAndInsurance,
        },
      },
    });
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        paymentAndInsurance: {
          ...initialValues,
          visaExpirationDate: initialValues?.visaExpirationDate
            ? moment(initialValues.visaExpirationDate)
            : null,
          workPermissionExpireDate: initialValues?.workPermissionExpireDate
            ? moment(initialValues.workPermissionExpireDate)
            : null,
          certificateOfStudyExpireDate: initialValues?.certificateOfStudyExpireDate
            ? moment(initialValues.certificateOfStudyExpireDate)
            : null,
          residencePermissionExpireDate: initialValues?.residencePermissionExpireDate
            ? moment(initialValues.residencePermissionExpireDate)
            : null,
        },
      }}
    >
      <EditFormWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:paymentAndInsurance.labels.headerTitle')}
        </Typography>
        <Button type="primary" htmlType="submit">
          {t('common:buttons.save')}
        </Button>
      </EditFormWrapper>
      <PaymentAndInsuranceFields
        isOwnData
        isEdit
        form={form}
        switcherDefaultData={{
          workPermissionNeeded: initialValues?.workPermissionNeeded,
          hasCertificateOfStudy: initialValues?.hasCertificateOfStudy,
          residencePermissionNeeded: initialValues?.residencePermissionNeeded,
        }}
      />
    </Form>
  );
};

export default PaymentAndInsuranceEdit;
